import { cn } from "@/lib/utils";
import { useRef, useState, useEffect } from "react";

const EllipsisChip = ({ label, variant = "default", onClick, onDelete, className }) => {
  const textRef = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsOverflowed(el.scrollWidth > el.clientWidth);
    }
  }, [label]);

  return (
    <div
      className="font-sans relative inline-block"
      onMouseEnter={() => isOverflowed && setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {/* CHIP */}
      <div
        onClick={onClick}
        className={cn(
          "max-w-[120px] px-2 py-[2px] text-sm rounded-full cursor-default select-none font-medium flex items-center gap-1 overflow-hidden",
          variant === "outlined" &&
            "border border-card-border text-foreground bg-primary-foreground",
          variant === "orangeOutline" &&
            "border border-orange-300 text-orange-300",
          variant === "default" &&
            "border border-card-border text-foreground bg-primary/20",
          variant === "filled" &&
            "text-white bg-primary",
          className
        )}
      >
        {/* TEXT - overflow detection here */}
        <span
          ref={textRef}
          className="text-[12px] truncate flex-1 block"
        >
          {label}
        </span>

        {/* CROSS ICON */}
        {onDelete && (
          <button
            onClick={onDelete}
            className="text-xs text-gray-500 hover:text-gray-700 flex-shrink-0"
          >
            ✕
          </button>
        )}
      </div>

      {/* TOOLTIP */}
      {showTooltip && (
        <div className="absolute -top-8 left-1/2 -translate-x-1/2 whitespace-nowrap text-foreground text-xs rounded px-2 py-1 shadow-lg z-10 bg-primary-foreground border border-card-border rounded-lg">
          {variant === "orangeOutline"
            ? `${label} - Yet to be approved by admin`
            : label}
        </div>
      )}
    </div>
  );
};

export default EllipsisChip;
